import * as qs from "qs";
import { useUrlQueryParams } from "@modules/core/hooks";
import { searchParamsAPI } from "@modules/core/config";
import { cleanObject } from "@modules/core/utils";
export var useUrlParams = function () {
    var _a = useUrlQueryParams(searchParamsAPI), param = _a[0], setParam = _a[1];
    return "?" + qs.stringify(cleanObject(param));
};
